import { AppDate } from '../envTypes';

export enum ProfileUserType {
  guest = 'guest',
  normal = 'normal',
  seller = 'seller',
  verifiedSeller = 'verifiedSeller',
}

export enum StoreType {
  Business = 'Business',
  Creator = 'Creator',
  CommentChat = 'CommentChat',
  VFS = 'VFS',
}

export enum PopStoreBioDomainType {
  Independent = 'independent',
  Alternative = 'alternative',
}

export enum PopStoreCreatorBusinessType {
  RealEstate = 'realestate',
  AvatarMe = 'avatarme',
  Generic = 'generic',
  AIEcho = 'aiecho',
  CreatorCoach = 'creatorcoach',
  BeautyFashionAffiliate = 'beautyfashionaffiliate'
}

export enum RegistrationVenueType {
  Event = 'event',
  Generic = 'generic',
}

export interface Profile {
  avatar?: string;
  username?: string;
  firstName: string;
  lastName: string;
  email: string;
  storeFrontName?: string;
  createdAt?: AppDate;
  updatedAt?: AppDate;
  hashtags?: Record<string, string>;
  userType?: ProfileUserType;
  storeType?: StoreType;
  urlCode?: string;
  bio?: string;
  badges?: {
    activeSeller?: boolean;
    staff?: boolean;
  };
  hideBadgeInProfile?: boolean;
  /** true if the firebase auth record for this profile is deleted (mainly for guest profile) */
  authDeleted?: boolean;
  customization?: string;
  apps?: {
    popStore?: boolean;
  };
  /** @deprecated use bioDomain instead */
  popStoreDomain?: string;
  bioDomain?: {
    domainName: string;
    type: PopStoreBioDomainType;
  };
  followersSettings?: { description?: string; active?: boolean };
  deleteRequested?: boolean;
  businessType?: PopStoreCreatorBusinessType;
  registrationVenue?: RegistrationVenueType;
  signInMessage?: {
    heading: string;
    subject: string;
    ctaText: string;
  };
}

export type BasicProfile = Pick<
  Profile,
  'firstName' | 'lastName' | 'username' | 'avatar'
>;
